import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Swipeable from 'react-swipeable'
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import MenuItem from '@material-ui/core/MenuItem';

import MetaBox from './inputs/MetaBox'
import InnerBar from './InnerBar';
import Question from './TestQuestion'
import FormSelect from './inputs/FormSelect'

import {
  get_test,
  reset_test,
  get_test_by_position
} from '../actions'

const styles = {
  root: {
    flexGrow: 1,
  },
  colorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
  barColorPrimary: {
    color: 'rgba(255,255,255,0)',
    backgroundColor: 'rgba(255,255,255,0)',
  },
}

const mapStateToProps = state => {
  const { fetching_single, test, fetched_single, items, pagination, errors, skip } = state.test
  return {
    test: test,
    fetching: fetching_single,
    fetched: fetched_single,
    tests: items,
    pagination: pagination,
    errors: errors,
    skip: skip,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getTest: test_id => dispatch( get_test(test_id) ),
    getPosition: (skip, filters, sort, order) => dispatch( get_test_by_position(skip, filters, sort, order) ),
    resetTest: () => dispatch( reset_test() )
  }
}

class ConnectedTestPreview extends React.Component {
  state = {
    loaded: false,
    skip: 0,
    total: 0,
    showBar: false,
    hideBar: true,
    variant: 'default'
  }

  componentWillMount() {
    // this.props.resetTest()
  }

  handleNext() {
    this.props.getPosition(this.state.skip + 1, this.props.filters || {}, this.props.order || '', this.props.sort || '')
  }

  handlePrevious() {
    this.props.getPosition(this.state.skip - 1, this.props.filters || {}, this.props.order || '', this.props.sort || '')
  }

  handleKeyDown(e) {
    if (e.keyCode === 37) {
      this.handlePrevious()
    } else if (e.keyCode === 39 ) {
      this.handleNext()
    }
  }

  swipingLeft(e, absX) {
    this.handleNext()
  }

  swipingRight(e, absX) {
    this.handlePrevious()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isopen) {
      return
    }

    if ( this.props.fetching && this.state.showBar === false ) {
      this.setState({showBar: true, hideBar: false})
      setTimeout( function(self) {
        self.setState({hideBar: true})
      }, 1000, this)
    } else if (!this.props.fetching && this.state.showBar) {
      this.setState({showBar: false})
    }

    if ( this.props.test_id && this.props.test_id !== prevProps.test_id && !this.props.fetching ) {
      this.props.getTest(this.props.test_id)
    }

    if (this.props.fetched && !prevProps.fetched) {
      const {page, per_page} = this.props.pagination
      this.setState({
        total: this.props.test.total === null ? this.props.pagination.total : this.props.test.total,
        skip: this.props.test.skip === null ?
          ((page - 1 ) * per_page ) + this.props.tests.findIndex( q => q.id === this.props.test.id ) :
          this.props.test.skip
      })
    }
  }

  handleChange(e) {
    const { value } = e.target
    this.setState({variant: value})
  }

  render() {
    if ( !this.props.isopen ) {
      return ''
    }

    if ( !this.props.test_id ) {
      return ''
    }

    const { test, isopen, handleClose, classes, current_user } = this.props
    const { variant } = this.state

    const { id, questions, skill, template, level, taken, human_time,
      user_email, user_name, coupon, template_version, actual_paid, competency_levels } = test

    let localIndex = -1

    return (
      <Dialog
        className="dialog-wrapper"
        fullScreen={false}
        fullWidth={true}
        maxWidth={'md'}
        open={isopen}
        onKeyDown={this.handleKeyDown.bind(this)}
        onClose={e => {
          handleClose()
        }}
      >
        <DialogContent className="dialog-content">
          <DialogTitle className="linear-progress-preview">
            {
              (this.state.showBar || !this.state.hideBar) ? (
                <LinearProgress />
              ) :   <LinearProgress classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }} />
            }
          </DialogTitle>
          <Swipeable
            onSwipingLeft={this.swipingLeft.bind(this)}
            onSwipingRight={this.swipingRight.bind(this)}>

            <Grid container spacing={24} justify="center" className="c-black087 mb-24 body2" alignItems="center">

              <Grid item>
                <Link to ='' className="novisit" onClick={e=>{
                  e.preventDefault()
                  this.handlePrevious()
                }}>Prev</Link>
              </Grid>

              <Grid item>
                {this.state.skip + 1}/{this.state.total}
              </Grid>

              <Grid item>
                <Link to ='' className="novisit" onClick={e=>{
                  e.preventDefault()
                  this.handleNext()
                }}>Next</Link>
              </Grid>

            </Grid>

            <div className="test_report_actions">
              <Grid container spacing={24} justify="space-between" className="c-black087 body2" alignItems="center">
                <Grid xs={12} md={8} item container justify="flex-start" alignItems="center">
                  <Grid item style={{marginRight: 12}}>
                    Sorting:
                  </Grid>
                  <Grid>
                    <FormSelect
                      value={this.state.variant}
                      className="someclass"
                      onChange={(e) => this.handleChange(e)}
                    >
                      <MenuItem value={'default'}>As served</MenuItem>
                      <MenuItem value={'level'}>Per Level</MenuItem>
                    </FormSelect>
                  </Grid>
                </Grid>
                <Grid xs={12} md={4} item className="instance-preview-download">
                  <Link to='' onClick={e => {
                    e.preventDefault()
                    this.props.download(this.props.test.id, this.state.variant)
                  }}>Download PDF</Link>
                </Grid>
              </Grid>
            </div>

            <Grid use="test data" container spacing={24} justify="space-around" className="mb-40">
              <Grid item xs={12} md={12}>

                <InnerBar text="TEST INFO" />
                <div className="test_report_info">
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <span className="d-inline-block fw-bold fs-12 mb-10">Static Data</span>
                      <MetaBox title="Test Instance" value={id}/>
                      <MetaBox title="Date Taken" value={taken ? new Date(taken).toLocaleDateString() : ''}/>

                    </Grid>
                    <Grid item md={4}>
                      <span className="d-inline-block fw-bold fs-12 mb-10">User Data</span>
                      <MetaBox title="User" value={user_email}/>
                      <MetaBox title="Name" value={user_name}/>
                      {
                        current_user.role === 'admin' && (
                          <React.Fragment>
                            <MetaBox title="Coupon" value={coupon ? coupon : 'N/A'}/>
                            <MetaBox title="Price" value={`€ ${actual_paid || '0.00'}`}/>
                          </React.Fragment>
                        )
                      }
                    </Grid>
                    <Grid item md={3}>
                      <span className="d-inline-block fw-bold fs-12 mb-10">Results</span>
                      <MetaBox title="Skill" value={skill}/>
                      <MetaBox title="Test Template" value={template}/>
                      <MetaBox title="Tmpl.Version" value={template_version}/>
                      <MetaBox title="CEFR Score" value={level}/>
                      <MetaBox title="Time" value={human_time}/>
                    </Grid>
                    <Grid item md={2}>
                      <span className="d-inline-block fw-bold fs-12 mb-10">Level/Competency</span>
                      <MetaBox title="Grammar" value={competency_levels["Grammar"]}/>
                      <MetaBox title="Vocabulary" value={competency_levels["Vocabulary"]}/>
                      <MetaBox title="Reading" value={competency_levels["Reading"]}/>
                      <MetaBox title="Listening" value={competency_levels["Listening"]}/>
                    </Grid>
                  </Grid>
                </div>

                { variant !== 'level' ? (
                  <React.Fragment>
                    <InnerBar text="QUESTIONS" />
                    {
                      questions.map( (question, i) => {
                        return <Question key={`test_question_${i}`} question={question} index={i+1}/>
                      })
                    }
                  </React.Fragment>
                ) : questions.map( q => q.level).sort().filter( (q, index, self) => self.indexOf(q) === index).map( (l, i) => {
                    const levelQuestions = questions.filter( q => q.level === l )
                    return (
                      <React.Fragment key={`innerbar_${l}`} >
                        <InnerBar text={`QUESTIONS ${l}`} />
                        { levelQuestions.map(question=> {
                          localIndex = localIndex + 1
                          return <Question key={`test_question_${localIndex}`} question={question} index={localIndex+1}/>
                        })}
                      </React.Fragment>
                    )
                  })
                }

              </Grid>
            </Grid>
            <Grid container spacing={24} justify="flex-end">
              <Button className="buttonnoto c-blue" onClick={this.props.handleClose}>Close</Button>
            </Grid>
          </Swipeable>
        </DialogContent>
      </Dialog>
    )
  }
}

const TestPreview = connect(mapStateToProps, mapDispatchToProps)(ConnectedTestPreview)

export default withStyles(styles)(TestPreview)



// WEBPACK FOOTER //
// ./src/js/components/TestPreview.js